var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1358_55152)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.45456 20.8172V11.5444L2.57878 8.91346L0 7.45349V19.1808C0 20.0862 0.733594 20.8172 1.63641 20.8172H5.45456Z",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5454 20.8172H22.3636C23.2691 20.8172 24 20.0835 24 19.1808V7.45361L21.0791 9.12583L18.5454 11.5444V20.8172Z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.45454 11.5444L5.06323 7.92121L5.45454 4.45349L12 9.36262L18.5454 4.45349L18.9832 7.73399L18.5454 11.5444L12 16.4535L5.45454 11.5444Z",
  fill: "#EA4335"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5454 4.45353V11.5444L24 7.45353V5.27169C24 3.24809 21.69 2.0945 20.0728 3.30809L18.5454 4.45353Z",
  fill: "#FBBC04"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 7.45345L2.50866 9.33502L5.45456 11.5443V4.45345L3.92719 3.30802C2.30719 2.09433 0 3.24802 0 5.27152V7.45336V7.45345Z",
  fill: "#C5221F"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1358_55152"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})))));
export default __webpack_public_path__ + "static/media/gmail.6f070886.svg";
export { SvgComponent as ReactComponent };